<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="title">{{'RESCHEDULE.TITLE' | translate}}</div>
    <div>{{'RESCHEDULE.DELIVERMSG' | translate}}</div>
    <div class="order-details">{{order.deliveryDate | date: 'MMMM d'}} &#124; {{order.deliveryHour}} </div>
    <div>{{'RESCHEDULE.ACCEPTMSG' | translate}}</div>
    <div class="confirm-btn">
      <button class="w-btn orange-btn" (click)="accept()">{{'RESCHEDULE.ACCEPT' | translate}}</button>
      <button class="w-link-btn" (click)="seeOptions()">{{'RESCHEDULE.OPTIONS' | translate}}</button>
    </div>
  </div>
</div>
